import { QueryProvider } from "./providers/QueryProvider";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "react-hot-toast";
import RootRouter from "./Router/RootRouter";

function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <Toaster position="top-right" />
        <RootRouter />
      </AuthProvider>
    </QueryProvider>
  );
}

export default App;
